import { createContext } from 'react';

export const ServiceWorkerContext = createContext({
  offlineReady: false,
  needRefresh: false,
  buildDate: '',
  updateServiceWorker: (reloadPage?: boolean | undefined) => new Promise<void>(() => {}),
});
